'use strict';

function CryptoWatch() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [_CryptoController, _ResponsiveLayout];

  this.init = function () {
    this._portalPresenter = document.getElementById('Portal').mogo();

    this._super();
    $(this.node).removeClass('hide');
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    // Required when route has defer_page_load_completed: true
    this._portalPresenter.setPageLoadComplete();

    if (window.location.pathname == this.paths.crypto.watch) {
      // Crypto Sunset
      var hasCryptoAccount = this.presenter.models.account.eligibility.crypto === true;
      if (!hasCryptoAccount) {
        // to prevent users clicking activation button send them to main dashboard.
        this._history.replaceUrl(this.paths.account.dashboard);
      }
    }
  };
}